const serverUrls = {
  "workspace_language_list": '/api/language/languages/',
}

export default {
  server: serverUrls,
};
